/** @format */

import React, { useState, useEffect } from 'react'

import Select from 'antd/lib/select'
import Row from 'antd/lib/row'
import Col from 'antd/lib/col'

import Images from '../../../../components/Commons/Images'
import CustomImage from '../../../../v2-components/Antd/Image'
import { Service } from '../../../carts/components/BagProductsGroup/service'
import { Enviroment } from '../../../../_config/constants/enviroment-v2.constant'

import PharmacyScheduleFunction from '../../../../components/HooksCheckout/Functions/PharmacySchedule'
import { pharmacyFeatures } from '../../../../v2-config/constants/pharmacy-features.constant'

import './style.scss'

const { Option } = Select

export default function PharmacySelect(props) {
	const [isDate, setDate] = useState(null)
	const [isTime, setTime] = useState(null)

	const [modules, setModules] = useState([])
	const [loadingModules, setLoadingModules] = useState(true)

	const handleSelectLocal = async (item, data) => {
		await PharmacyScheduleFunction(item, data, props.order).then((response) => {
			if (response) {
				props.order.info.pharmacy.forEach((element) => {
					if (item === element.pharmacy) {
						setDate(response)
					}
				})
			}
		})
	}

	useEffect(() => {
		if (props.order?.info?.pharmacy?.length > 0) {
			const item = props.order.info.pharmacy[0]
			handleSelectLocal(item.pharmacy, item.local)
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [props.order.info.pharmacy])

	const handleDateSelected = (item) => {
		props.setInfoSelected((pvSt) => ({
			...pvSt,
			date: !!item ? item : '',
		}))
		isDate.forEach((element) => {
			if (item === element.date) {
				setTime(element.timers)
			}
		})
	}

	const handleTimeSelected = (item) => {
		props.setInfoSelected((pvSt) => ({
			...pvSt,
			time: !!item ? item : '',
		}))
	}

	return (
		<>
			{props.order.info.pharmacy.map((item, index) => (
				<div className='ph-objected-recipe-pharmacy-list-global-container' key={index}>
					<Row className='ph-recipe-objeted-pharmacy-list-main-container'>
						<Col xs={24}>
							<div className='ph-recipe-objeted-pharmacy-list-container'>
								<div className='ph-recipe-objeted-pharmacy-image-container'>
									{loadingModules ? (
										<></>
									) : (
										<CustomImage
											className='ph-recipe-objeted-pharmacy-image'
											src={
												(modules.find((m) => m.location === 'icon-and-favicon')?.image) || item.image || 'https://storage.googleapis.com/tirx-resources-develop/817f55db-81a6-46a4-affd-ac46d05deaa0.png'
											}
											alt={item.name_editable}
											title={item.name_editable}
										/>
									)}
								</div>
								<h3 className='ph-recipe-objeted-pharmacy-list-title'>
									   {item.name_pharmacy}
								</h3>
							</div>
							<h3 className='ph-recipe-objeted-pharmacy-list-description' style={{padding:'6px'}}>
								{/* Farmacias disponibles para su retiro... */}
							</h3>
						</Col>
						{/* <Col xs={6} className='ph-recipe-objeted-pharmacy-btn-container'>
							<Button
								onClick={() => handleSelectLocal(item.pharmacy, item.local)}
								className='ph-recipe-objeted-pharmacy-btn'>
								Seleccionar
							</Button>
						</Col> */}
					</Row>
					<div className='ph-recipe-objeted-pharmacy-inputs-container'>
						{isDate && (
							<Select
								className='ph-recipe-objeted-pharmacy-local-selector'
								size='large'
								allowClear
								placeholder='Selecciona una Fecha'
								onChange={(value) => handleDateSelected(value, item)}>
								{isDate.map((element, i) => (
									<Option value={element.date} key={i}>
										{element.date}
									</Option>
								))}
							</Select>
						)}
						{isTime && pharmacyFeatures.deliveryTimeSelect && (
							<Select
								className='ph-recipe-objeted-pharmacy-local-selector'
								size='large'
								allowClear
								placeholder='Selecciona el Horario'
								onChange={(value) => handleTimeSelected(value, item)}>
								{isTime.map((element, i) => (
									<Option value={`${element.start} - ${element.finish}`} key={i}>
										{`${element.start} - ${element.finish}`}
									</Option>
								))}
							</Select>
						)}
					</div>
				</div>
			))}
		</>
	)
}
